import type { Device, DeviceStatus } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

const useDevices = (
  status?: DeviceStatus,
  enabled?: boolean,
  page?: number,
  perPage?: number
) => {
  const { isLoading, data, refetch } = useQuery<GetListQueryResponse>(
    `devices-carer-${status}-${page}-${perPage}`,
    () => getJSON({ url: getListQuery(status, page, perPage) }),
    {
      enabled
    }
  )

  return {
    devices: data?.result as Device[],
    count: data?.count,
    isLoading,
    refetch
  }
}

export type GetListQueryResponse = {
  result?: Device[]
  count?: number
}

const getListQuery = (status?: DeviceStatus, page?: number, perPage?: number) =>
  `/api/list/devices/?${getQueryParams({
    status,
    ...(page && { 'pagination[page]': page }),
    ...(perPage && { 'pagination[itemsPerPage]': perPage })
  })}`

export default useDevices
